import { useState, useEffect } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../Modules/General"
import CoordinateModule from "../Modules/CoordinateModule"

export default function EmoticonProperties( props )
{
    const layers = props.layers 
    const setLayers = props.setLayers 
    const layersCfg = props.layersCfg
    const selected = props.selected 
    const selectedIdx = props.selectedIdx
    const modalOpen = props.modalOpen
    const accountType = props.accountType
    const reset = props.reset

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const setManualSelectedCoords = props.setManualSelectedCoords

    const [ name, setName ] = useState(null)
    const [ source, setSource ] = useState(null)

    const reload = () => {
        if( selectedIdx < 0 )
        {
            return;
        }

        if( !layersCfg.current[selected] )
        {
            return
        }

        let properties = layersCfg.current[selected].properties

        if( properties == null )
        {
            properties = {}
        }

        let n = layersCfg.current[selected].name 
        setName( n || "" )

        setSource( properties.source || "last")
    }

    useEffect( () => {
        reload()
    }, [reset] )

    useEffect( () => {
        if( source == null || name == null )
        {
            return
        }

        var data = {
            source: source,
        }

        layersCfg.current[selected].properties = data
        layersCfg.current[selected].name = name

        setLayers([...layers])

    },[ source, name ])

    return (
        <>
            <CoordinateModule coordinates={selectedCoords}
                setCoordinates={setSelectedCoords}
                selected={selected}
                setManual={setManualSelectedCoords}
            />

            {/*<SettingsGroup name="General">
                <Control name="Name">
                    <Form.Control value={name} onChange={ e => setName(e.target.value)} size="sm"/>
                </Control>
            </SettingsGroup>*/}
            <SettingsGroup name="Data source">
                { source &&
                <Control name="Source">
                    <Form.Select style={{width:'100%'}} size="sm" 
                             value={source} 
                             onChange={ e => setSource( e.target.value )}
                    >
                        <option value="last">Last</option>
                        <option value="super_emot_1">Super Emot (1 min)</option>
                        <option value="super_emot_5">Super Emot (5 min)</option>
                    </Form.Select>
                </Control>
                }
            </SettingsGroup>
        </>
    )
}
